import React, { FC, useMemo } from 'react';
import { alpha, Box } from '@mui/material';
import {
  detailsDrawerInit,
  getDetailsDrawerType,
} from 'src/DetailsDrawer/store/detailsDrawerSlice';
import { connect } from 'react-redux';
import { RootState } from 'src/store';
import ChipButton from 'src/components/ChipButton';
import ConfirmIcon from '@mui/icons-material/CheckOutlined';
import { DETAILS_DRAWER_CONTROLLER_HEIGHT } from '../../utils';
import { Dispatch } from 'redux';

type OwnProps = {
  isDisabled?: boolean;
  onActionClick?: () => void;
};

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

const DetailsController: FC<Props> = ({
  type,
  isDisabled,
  onActionClick,
  onCloseDetailsDrawer,
}) => {
  const Controllers = useMemo(() => {
    const BaseControllers = [
      <ChipButton
        variant="text"
        key="controller-0"
        sx={{
          padding: ({ spacing }) => spacing(0.5, 1.5),
          minWidth: 'unset',
        }}
        onClick={onCloseDetailsDrawer}
      >
        ביטול
      </ChipButton>,
    ];

    switch (type) {
      case 'RECEIPTS_VIEW': {
        return null;
      }
      case 'RECEIPTS_CREATE': {
        return [
          ...BaseControllers,
          <ChipButton
            key="controller-1"
            color="primary"
            sx={{
              padding: ({ spacing }) => spacing(0.5, 2, 0.5, 1.25),
              fontWeight: 600,
              background: ({ palette }) =>
                alpha(palette.primaryLight80 ?? '', 0.25),
              '&:hover': {
                background: ({ palette }) =>
                  alpha(palette.primaryLight80 ?? '', 0.25),
              },
            }}
            endIcon={
              <ConfirmIcon
                sx={{
                  fontSize: 18,
                }}
              />
            }
            onClick={onActionClick}
            disabled={isDisabled}
          >
            שמירה
          </ChipButton>,
        ];
      }
      case 'REPORTS_AUTOMATIONS_VIEW': {
        return null;
      }
      case 'REPORTS_AUTOMATIONS_CREATE': {
        return null;
      }
      default: {
        return null;
      }
    }
  }, [type]);

  return (
    <Box
      display="flex"
      position="relative"
      sx={{
        padding: ({ spacing }) => spacing(0, 2.5, 0, 4),
        minHeight: DETAILS_DRAWER_CONTROLLER_HEIGHT,
        maxHeight: DETAILS_DRAWER_CONTROLLER_HEIGHT,
      }}
    >
      <Box
        display="flex"
        gap={1}
        flex={1}
        justifyContent="flex-end"
        alignItems="center"
      >
        {Controllers}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state: RootState) => ({
  type: getDetailsDrawerType(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onCloseDetailsDrawer: () => dispatch(detailsDrawerInit({ type: null })),
});

export default connect(mapStateToProps, mapDispatchToProps)(DetailsController);
